import type { EffectivePermission, PermissionContext } from "./types";

const valueMatches = (required: string, actual: string): boolean =>
  required === actual || actual === "*";

const entryMatchesResourceAction = (
  entry: EffectivePermission,
  resource: string,
  action: string
): boolean => valueMatches(resource, entry.resource) && valueMatches(action, entry.action);

const entryScopeApplies = (entry: EffectivePermission, firmId?: string): boolean => {
  if (entry.scope === "global") {
    return true;
  }
  if (entry.scope !== "firm" || !firmId) {
    return false;
  }
  return entry.firm_ids?.includes(firmId) ?? false;
};

const entryConditionApplies = (entry: EffectivePermission): boolean => {
  // assigned / managed:assigned conditions are not resolvable client-side
  return entry.condition === "all";
};

export const evaluateCan = (
  permissions: EffectivePermission[],
  resource: string,
  action: string,
  ctx?: PermissionContext
): boolean => {
  for (const entry of permissions) {
    if (!entryMatchesResourceAction(entry, resource, action)) {
      continue;
    }
    if (!entryScopeApplies(entry, ctx?.firm_id)) {
      continue;
    }
    if (entryConditionApplies(entry)) {
      return true;
    }
  }
  return false;
};

export const evaluateCanOptimistic = (
  permissions: EffectivePermission[],
  resource: string,
  action: string,
  ctx?: PermissionContext
): boolean => {
  for (const entry of permissions) {
    if (!entryMatchesResourceAction(entry, resource, action)) {
      continue;
    }
    if (entryScopeApplies(entry, ctx?.firm_id)) {
      return true;
    }
  }
  return false;
};
